
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.52 16.813c-2.234 0-4.134-.775-5.7-2.325-1.567-1.55-2.35-3.441-2.35-5.675v-.175l-1.6 1.6-1.4-1.4 4-4 4 4-1.4 1.4-1.6-1.6v.175c0 1.667.587 3.084 1.762 4.25 1.175 1.167 2.604 1.75 4.287 1.75.434 0 .859-.05 1.275-.15.417-.1.825-.25 1.225-.45l1.5 1.5a8.247 8.247 0 01-1.95.825 7.693 7.693 0 01-2.05.275zm6.95-4.025l-4-4 1.4-1.4 1.6 1.6v-.175c0-1.666-.588-3.083-1.763-4.25-1.175-1.166-2.604-1.75-4.288-1.75-.433 0-.858.05-1.275.15-.416.1-.825.25-1.225.45l-1.5-1.5a8.251 8.251 0 011.95-.825 7.696 7.696 0 012.05-.275c2.234 0 4.134.775 5.7 2.325 1.567 1.55 2.35 3.442 2.35 5.675v.175l1.6-1.6 1.4 1.4-4 4z"}})])
          )
        }
      }
    